export default {
    title: 'Geräte, Ausstattungs- und Ausrüstungskosten',
    addEquipmentCosts: 'Eintrag hinzufügen',
    listing: {
        description: 'Beschreibung',
        amount: 'Betrag',
    },
}